import React from 'react';
import {singleInput} from './type';

const SingleInput = ({
  setValue,
  value,
  name,
  placeholder,
  onBlur,
}: singleInput) => {
  return (
    <div className="w-full flex flex-col gap-2 ">
      <input
        type="text"
        id={name}
        name={name}
        placeholder={placeholder}
        onBlur={onBlur}
        autoComplete={'off'}
        className="w-full rounded-lg p-[12px] !border !border-gray-300 outline-0 text-sm text-gray-800 bg-transparent"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setValue(e.target.value);
        }}
        value={value}
      />
    </div>
  );
};

export default SingleInput;
